import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeSelectedAlarms: [],
  alarms: [],
};
const scheduledModeSlice = createSlice({
  name: 'scheduledMode',
  initialState,
  reducers: {
    resetState() {
      return { ...initialState };
    },
    setActiveSelectedAlarms(state, action) {
      state.activeSelectedAlarms = action.payload;
    },
    setAlarms(state, action) {
      state.alarms = action.payload;
    },
  },
});

export const scheduledModeActions = scheduledModeSlice.actions;

export default scheduledModeSlice;
